import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { retry } from 'rxjs/operator/retry';

import { environment } from '../../environments/environment';


@Injectable()
export class VerifyService {

  Version: string = environment.appVersion;

  constructor(
    private http: HttpClient,
    private toastr: ToastsManager,
    private router: Router) { }
    headers = new HttpHeaders().set('Content-Type', 'application/json');

  // getToken() {
  //   return localStorage.getItem('key'); //token
  // }

  public checkToken() {
    if (localStorage.getItem('key') !== '') {
      return true;
    } else {
      const redirect = '/web';
      this.router.navigate([redirect]);
    }
  }

  public getUrl() {
    return document.getElementsByTagName('base')[0].href;
  }

  public idProject() {
    return 4;
  }

  public getVersion() {
    return this.Version;
  }

  public verifyResponse(response) {
    if (response.Result) {
      return true;
    } else {
      if (response.Codigo === 0) {
        this.redirectWeb();
      } else if (response.Codigo < 0) {
        this.toastr.error(response.Message, 'Error!', { toastLife: 10000, showCloseButton: true });
        return false;
      } else {
        // this.dataStr.emit('response');
        return true;
      }
    }
  }

  private redirectWeb() {
    this.toastr.info('Su sesión ha expirado, sera redireccionado.');
    localStorage.setItem('key', '');
    const redirect = '/web';
    this.router.navigate([redirect]);
  }

  private sessionStatus(): Observable<any> {
    const obj = {
      UserToken: localStorage.getItem('key')
    };
    const json = JSON.stringify(obj);

    return this.http.post<any>(this.getUrl() + 'Home/IsActiveSession', json, {headers: this.headers})
      .catch(error => {
        return Observable.throw('An error occurred:', error.error.message);
      });
  }

  public verifySession() {
    this.sessionStatus().subscribe(resp => {
      if (resp.Result) {
        return true;
      } else {
        this.redirectWeb();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/global/verify.service.ts